import { LenderKreaFeatures } from "../components/lender-krea-features";
import { LenderProfileDetailsSection } from "../components/lender-profile-details-section";

export const LenderProfilePage = () => {
  return (
    <div className="mx-auto max-w-6xl space-y-8 p-8">
      <LenderProfileDetailsSection />
      <LenderKreaFeatures />
    </div>
  );
};
